import React from "react";
import { Link } from "react-router-dom";
import { Wallet, Image, ScrollText, Gift, Settings as SettingsIcon, ShieldAlert, Swords, Trophy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/assets";
import BadgeCard from "@/components/BadgeCard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  const cards = [
    { to: "/settings", label: "Connected Wallets", d: "EVM + Solana linking at launch", Icon: Wallet },
    { to: "/battles", label: "Meme Battles", d: "Enter this week's showdown", Icon: Swords },
    { to: "/leaderboard", label: "Leaderboard", d: "See where you rank", Icon: Trophy },
    { to: "/my/memes", label: "My Memes", d: "Everything you've posted", Icon: Image },
    { to: "/my/stories", label: "My Stories", d: "Your confessions", Icon: ScrollText },
    { to: "/rewards", label: "Rewards", d: "Prep for future drops", Icon: Gift },
    { to: "/profile", label: "Profile", d: "Your community identity", Icon: SettingsIcon },
  ];
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
      <div className="flex items-center gap-4">
        {user.picture
          ? <img src={user.picture} alt="me" className="w-16 h-16 rounded-full border-3 border-neon" />
          : <img src={ASSETS.pointing} alt="me" className="w-16 h-16" />}
        <div>
          <span className="tag">The Robbed Crew</span>
          <h1 className="headline text-cream text-3xl sm:text-4xl mt-2">GM, {user.displayName || "ROBBED"}.</h1>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-4 mt-10 items-start">
        <BadgeCard />
        <div className="grid sm:grid-cols-2 gap-4">
          {cards.map((c) => (
            <Link key={c.label} to={c.to} className="comic-card p-5 hover:border-neon transition-colors" data-testid={`dash-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <c.Icon className="w-7 h-7 text-neon" />
              <h3 className="font-display font-900 text-cream uppercase text-sm mt-3">{c.label}</h3>
              <p className="font-mono text-xs text-dim mt-1">{c.d}</p>
            </Link>
          ))}
        </div>
      </div>

      <div className="comic-card p-5 mt-6 flex items-start gap-3 bg-[#0f1a0f]">
        <ShieldAlert className="w-6 h-6 text-neon shrink-0" />
        <p className="font-mono text-[12px] text-dim leading-relaxed">
          Wallet balances, holder status, rewards and airdrop eligibility will appear here only after $ROBBED is
          verifiably live on-chain. We never fabricate balances or holders.
        </p>
      </div>
    </div>
  );
}
